/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetDocumentFilterResponseData,
  GetDocumentFilterResponseDataFromJSON,
  GetDocumentFilterResponseDataFromJSONTyped,
  GetDocumentFilterResponseDataToJSON
} from './GetDocumentFilterResponseData'

/**
 *
 * @export
 * @interface GetSiteFilterResponse
 */
export interface GetSiteFilterResponse {
  /**
   *
   * @type {number}
   * @memberof GetSiteFilterResponse
   */
  status?: number
  /**
   *
   * @type {GetDocumentFilterResponseData}
   * @memberof GetSiteFilterResponse
   */
  data?: GetDocumentFilterResponseData
}

export function GetSiteFilterResponseFromJSON(json: any): GetSiteFilterResponse {
  return GetSiteFilterResponseFromJSONTyped(json, false)
}

export function GetSiteFilterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSiteFilterResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetDocumentFilterResponseDataFromJSON(json['data'])
  }
}

export function GetSiteFilterResponseToJSON(value?: GetSiteFilterResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetDocumentFilterResponseDataToJSON(value.data)
  }
}
